<input (ngModelChange)='inputChanged($event)'  [ngModel]='displayedCode' pInputText 
       placeholder='Code' type='text'>
